import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: auto;
  padding: 0 var(--cms-grid-column-gap, 0.186rem);
  gap: var(--cms-grid-row-gap, 0.186rem) var(--cms-grid-column-gap, 0.186rem);

  > div {
    flex: 0 0 auto;
  }
`
